import { ViewModel, View, ObservableArray } from "binder"
import { ProductionOrderManipulationView } from "./productionOrderManipulation-view"
import { ServerConnection } from "src/server/serverConnection";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import { ProductionOrderEditorViewModel, ProductionOrderInserter } from "./productionOrderEditor/productionOrderEditor-viewModel";
import { getAsNumber } from "src/uicomponents/components/utilities";
import { ProductLineSelectorViewModel } from "./Selectors/productLineSelector-viewModel";
import { WorkingShiftSelectorViewModel } from "../shiftAssignmentManipulation/workingShiftSelector-viewModel";
import { WorkStationSelectorViewModel } from "../productionStopListManipulation/Selectors/workStationSelector-viewModel";

export class ProductionOrderManipulationViewModel extends WindowViewModel {
    public getTitle(): string {
        return 'تعریف برنامه تولید';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

        this.isLoading = false;
        this.productionOrders = ObservableArray.create<ProductionOrder>();
        this.dataLoader = new ServerSideDataLoader(filteringInformation => this.refreshPaged(filteringInformation), 30);

        this.refresh()
    }
    GetDefaultView(): View<ViewModel> {
        return new ProductionOrderManipulationView();
    }
    public getTypeId(): string {
        return "VM-221BBB07-8CE7-490E-A7B2-743F7863542B"
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set productionOrders(v: ObservableArray<ProductionOrder>) { this._productionOrders = v; } public get productionOrders(): ObservableArray<ProductionOrder> { return this._productionOrders; } private _productionOrders: ObservableArray<ProductionOrder>;
    public set dataLoader(v: ServerSideDataLoader) { this._dataLoader = v; } public get dataLoader(): ServerSideDataLoader { return this._dataLoader; } private _dataLoader: ServerSideDataLoader;

    async refresh() {
        await this.dataLoader.refresh();
    }

    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/ToolInstallationServices/ProductionOrdersList', {
                FilteringInformation: filteringInformation
            });

            this.productionOrders.update(...result.ProductionOrders.map((x, i) => {
                let t = new ProductionOrder(this);
                t.index = ((result.PaginationInfo.CurrentPage - 1) * result.PaginationInfo.PageSize) + i + 1;
                t.id = x.ProductionOrderId;
                t.code = x.ProductionOrderCode;
                t.productId = x.ProductId;
                t.productCode = x.ProductCode;
                t.productName = x.ProductName;
                t.time = x.Time;
                t.setUntil(x.SerialCodes);
                t.setFrom(x.SerialCodes);
                return t;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage, result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0, 0);
        } finally {
            this.isLoading = false;
        }
    }

    async addNew() {
        let popup = new ProductionOrderEditorViewModel(this, new ProductionOrderInserter());
        let result = await this.showPopup(popup);
        if (result == 'done') {
            this.dataLoader.refresh();
        }
    }

    async showDetail(productionOrder: IProductionOrder) {
        let popup = new ProductionOrderEditorViewModel(this, new ProductionOrderInserter(), true);
        await productionOrder.cloneTo(popup);
        let result = await this.requestShowingPopup(popup);
        if (result == 'done') {
            this.dataLoader.refresh();
        }
    }
}

export class ProductionOrder extends ViewModel implements IProductionOrder {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ProductionOrderManipulationViewModel) {
        super(parent);
        this._typedParent = parent;
        this.serialNumbers = ObservableArray.create<string>();
    }

    private _typedParent: ProductionOrderManipulationViewModel;
    public set index(v: number) { this._index = v; } public get index(): number { return this._index; } private _index: number;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code; } private _code: string;
    public set productionOrderId(v: string) { this._productionOrderId = v; } public get productionOrderId(): string { return this._productionOrderId; } private _productionOrderId: string;
    public set productId(v: string) { this._productId = v; } public get productId(): string { return this._productId; } private _productId: string;
    public set productName(v: string) { this._productName = v; } public get productName(): string { return this._productName; } private _productName: string;
    public set productCode(v: string) { this._productCode = v; } public get productCode(): string { return this._productCode; } private _productCode: string;
    public set serialNumbers(v: ObservableArray<string>) { this._serialNumbers = v; } public get serialNumbers(): ObservableArray<string> { return this._serialNumbers; } private _serialNumbers: ObservableArray<string>;
    public set productLineId(v: string) { this._productLineId = v; } public get productLineId(): string { return this._productLineId; } private _productLineId: string;
    public set productLineSelector(v: ProductLineSelectorViewModel) { this._productLineSelector = v; } public get productLineSelector(): ProductLineSelectorViewModel { return this._productLineSelector; } private _productLineSelector: ProductLineSelectorViewModel;
    public set workingShiftId(v: string) { this._workingShiftId = v; } public get workingShiftId(): string { return this._workingShiftId; } private _workingShiftId: string;
    public set workingShiftSelector(v: WorkingShiftSelectorViewModel) { this._workingShiftSelector = v; } public get workingShiftSelector(): WorkingShiftSelectorViewModel { return this._workingShiftSelector; } private _workingShiftSelector: WorkingShiftSelectorViewModel;
    public set workStationId(v: string) { this._workStationId = v; } public get workStationId(): string { return this._workStationId; } private _workStationId: string;
    public set workStationSelector(v: WorkStationSelectorViewModel) { this._workStationSelector = v; } public get workStationSelector(): WorkStationSelectorViewModel { return this._workStationSelector; } private _workStationSelector: WorkStationSelectorViewModel;
    public set from(v: number) { this._from = v; } public get from(): number { return this._from; } private _from: number;
    public set until(v: number) { this._until = v; } public get until(): number { return this._until; } private _until: number;
    public set time(v: string) { this._time = v; } public get time(): string { return this._time; } private _time: string;

    setProductId(id: string) {
        this.productId = id;
    }
    getProductId(): string {
        return this.productId;
    }

    setProductName(name: string) {
        this.productName = name;
    }
    getProductName(): string {
        return this.productName;
    }

    setProductLineId(id: string) {
        this.productLineId = id;
    }
    getProductLineId(): string {
        return this.productLineId;
    }

    setWorkingShiftId(id: string) {
        this.workingShiftId = id;
    }
    getWorkingShiftId(): string {
        return this.workingShiftId;
    }

    setWorkStationId(id: string) {
        this.workStationId = id;
    }
    getWorkStationId(): string {
        return this.workStationId;
    }

    setSerialNumbers(serialNumbers: string[]) {
        this.serialNumbers.update(...serialNumbers);
    }
    getSerialNumbers(): string[] {
        return this.serialNumbers;
    }

    setUntil(input: any) {
        if (input.length == 0) {
            this.until = 0;
            return;
        }
        this.until = Math.max(...input.map(item => getAsNumber(item.SerialNo)));
    }
    getUntil(): number {
        return this.until;
    }

    setFrom(input: any) {
        if (input.length == 0) {
            this.from = 0;
            return;
        }
        this.from = Math.min(...input.map(item => getAsNumber(item.SerialNo)));
    }
    getFrom(): number {
        return this.from;
    }

    async cloneTo(productionOrder: IProductionOrder) {
        productionOrder.id = this.id;
        productionOrder.code = this.code;
        productionOrder.time = this.time;
        productionOrder.setProductId(this.getProductId());
        productionOrder.setProductName(this.getProductName());
        productionOrder.setProductLineId(this.getProductLineId());
        productionOrder.setWorkingShiftId(this.getWorkingShiftId());
        productionOrder.setWorkStationId(this.getWorkStationId());
        productionOrder.setSerialNumbers(this.getSerialNumbers());
        productionOrder.setFrom(this.getFrom());
        productionOrder.setUntil(this.getUntil());
    }

    async showDeatil() {
        this._typedParent.showDetail(this);
    }
}
